import Card from "@/components/custom/card";
import { Mixpanel } from "@/lib/mixpanel";
import { BudgetCategory } from "@/lib/types";
import { currencyFormatter } from "@/lib/utils";
import { useGetBudgetSubCategories } from "@/services/queries/budgets";
import { AnchorSimple } from "@phosphor-icons/react";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const BudgetCardItem = ({
  id,
  name,
  allocatedAmount,
  currencyCode,
}: BudgetCategory) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data } = useGetBudgetSubCategories({ id });

  const subCategories = useMemo(() => {
    return data?.value || [];
  }, [data]);

  return (
    <Card
      onClick={() => {
        navigate(`/budgets/${id}`);
        Mixpanel.track("Budget Card Clicked");
      }}
      data-testid={`category-card-${id}`}
      key={id}
    >
      <div className="flex flex-row items-center justify-center gap-[14px]">
        <div className="flex h-[50px] w-[50px] items-center justify-center rounded-full border border-white/20 p-[2px]">
          <span className="mt-[1.5px] flex h-full w-full items-center justify-center rounded-full bg-[url('/images/logo-bg.png')] bg-cover bg-center bg-no-repeat p-[10px] text-[17px] font-semibold leading-[22px] text-white">
            <AnchorSimple size={24} />
          </span>
        </div>

        <div className="flex flex-col items-start justify-start">
          <span className="text-base font-medium leading-5 text-white">
            {name}
          </span>
          <span className="flex items-center gap-2 text-xs font-medium text-white/50">
            <span className="flex h-[6px] min-w-[6px] rounded-full bg-[#316079]" />{" "}
            {`${subCategories.length} ${t("label.sub_category")}`}
          </span>
        </div>
      </div>

      <span
        data-testid={`category-amount-${id}`}
        className="text-[15px] font-medium leading-5 text-[#7ECEE8]"
      >
        {currencyFormatter(allocatedAmount, currencyCode)}
      </span>
    </Card>
  );
};

export default BudgetCardItem;
